/// <reference path="../lib/jquery.d.ts" />


export class LinkListControl {

    private listContainerItemsLeft: JQuery = $('.deskTop .resourceBody .column.left p');
    private listContainerItemsRight: JQuery = $('.deskTop .resourceBody .column.right ul');
    private title: JQuery = $('.deskTop .resourceBody .column p');
    private elementForConstruction: JQuery = $('.multiCardHolder');
    private window: JQuery = $(window);

    constructor() {
        
        // this.window.resize(() => {
        //
        //     if (this.window.width() <= 768) {
        //
        //         $('.multiCardHolder').flickity();
        //     }
        //     else
        //     {
        //         $('.multiCardHolder').flickity('destroy');
        //     }
        // });
        
        this.title.on('click', (e)=>{
            e.preventDefault();
            
            let selectedItem = ".item" + e.target.className;
            if (!$(e.target).hasClass("on"))
            {
                $(this.listContainerItemsRight).addClass('hide');
                $(selectedItem).removeClass("hide");

                $(this.listContainerItemsLeft).removeClass('on');
                $(e.target).addClass("on");
            }
        });
    }
}